import { useCallback } from 'react';
import { useLocation, useNavigate, type Location } from 'react-router';
import { useSession } from '../stores/session';

export function loginPath(next: string | Pick<Location, 'pathname' | 'search'>): string {
  const target = typeof next === 'string' ? next : next.pathname + next.search;
  return `/login?next=${encodeURIComponent(target)}`;
}

/** Returns a guard: true when signed in, otherwise sends the user to log in (and back). */
export function useRequireLogin(): (next?: string) => boolean {
  const user = useSession((s) => s.user);
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(
    (next?: string) => {
      if (user) return true;
      void navigate(loginPath(next ?? location));
      return false;
    },
    [user, navigate, location],
  );
}
